import { render } from "./HealthyPage.vue?vue&type=template&id=35c839ea&scoped=true"
import script from "./HealthyPage.vue?vue&type=script&lang=js"
export * from "./HealthyPage.vue?vue&type=script&lang=js"

import "./HealthyPage.vue?vue&type=style&index=0&id=35c839ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c839ea"]])

export default __exports__